export const keyboardLetters = [
  ['Q', 'W', 'E', 'É', 'R', 'T', 'Y', 'U', 'I', 'Í', 'O', 'Ó', 'P'],
  ['Á', 'A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'Ñ', 'Ú'],
  ['Z', 'X', 'C', 'V', 'B', 'N', 'M'],
]

export const letters = [
  'A',
  'Á',
  'B',
  'C',
  'D',
  'E',
  'É',
  'F',
  'G',
  'H',
  'I',
  'Í',
  'J',
  'K',
  'L',
  'M',
  'N',
  'Ñ',
  'O',
  'Ó',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'Ú',
  'V',
  'W',
  'X',
  'Y',
  'Z',
]

export const status = {
  green: 'green',
  yellow: 'yellow',
  gray: 'gray',
  unguessed: 'unguessed',
}
